import React from 'react';
import ReactDOM from 'react-dom';

import { overrideComponent, setMetadata, setOptions } from '@sheerid/jslib';
import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';
import { StepInactiveMilitaryPersonalInfoComponent } from './components/steps/StepMilitaryPersonalInfo/StepInactiveMilitaryPersonalInfoComponent';
import { StepActiveMilitaryPersonalInfoComponent } from './components/steps/StepMilitaryPersonalInfo/StepActiveMilitaryPersonalInfoComponent';
import { StepCollectMilitaryStatusComponent } from './components/steps/StepMilitaryPersonalInfo/StepCollectMilitaryStatusComponent';
import { StepSuccessComponent } from './components/steps/StepSuccessComponent';
import { babyDueDateValidator, returnToWorkValidator } from './Validators/customFieldValidators';

import App from './App';
import './index.css';

setOptions(defaultOptions);
googleTagManagerHook();

babyDueDateValidator();
returnToWorkValidator();

setMetadata({
    babyDueDate: '',
    returnToWork: '',
    communicationOptIn: true,
});

// @ts-ignore
overrideComponent('StepInactiveMilitaryPersonalInfoComponent', StepInactiveMilitaryPersonalInfoComponent);

// @ts-ignore
overrideComponent('StepActiveMilitaryPersonalInfoComponent', StepActiveMilitaryPersonalInfoComponent);

overrideComponent('StepCollectMilitaryStatusComponent', StepCollectMilitaryStatusComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent);

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
